import axios from 'axios'
import cookie from 'vue-cookie'
import { checklistApi } from '@/plugins/checklist_api'
import { startConnection, stopConnection } from '@/plugins/signalR'

export default {
  login ({ commit }, loginModel) {
    return new Promise((resolve, reject) => {
      axios.post('auth', loginModel).then(response => {
        var date = new Date()
        date.setDate(date.getDate() + 4)
        let { id, name, token, role, email, username, sharepointconfigdone, sendmailnotification } = response.data
        let user = JSON.stringify({ id, name, role, email, username, sharepointconfigdone, sendmailnotification })
        cookie.set('kilab_token', token, { expires: date, SameSite: 'Strict' })
        cookie.set('kilab_user', user, { expires: date, SameSite: 'Strict' })
        commit('authLogin', { authToken: token, user: JSON.parse(user) })
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
        startConnection()
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  logout ({ commit }) {
    cookie.delete('kilab_token')
    cookie.delete('kilab_user')
    commit('logout')
    stopConnection()
  },
  deleteHandler ({ commit }, model) {
    return new Promise((resolve, reject) => {
      let modelObj = { data: { ids: model.ids } }
      if (model.fromCheckList) {
        checklistApi.delete(model.url, modelObj)
          .then(() => {
            resolve()
          })
          .catch((error) => {
            reject(error)
          })
      } else {
        axios.delete(model.url, modelObj)
          .then(() => {
            resolve()
          })
          .catch((error) => {
            reject(error)
          })
      }
    })
  },
  deleteSingleRecordHandler ({ commit }, model) {
    return new Promise((resolve, reject) => {
      axios.delete(model.url)
        .then(() => {
          resolve()
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  /**
   * GET ALL PRODUCT UNITS
   */
  getUnits ({ commit }) {
    return new Promise((resolve, reject) => {
      let model = {
        'filter': 'isactive eq 1',
        'order_by': { field: 'name', asc_or_desc: 'asc' }
      }
      axios.post('productunits/query', model)
        .then((response) => {
          let model = { type: 'listOfUnits', data: response.data }
          commit('listValues', model)
          resolve()
        })
    })
  },
  /**
   * GET ALL SALES ACCOUNT
   */
  getSalesAccount ({ commit }) {
    return new Promise((resolve, reject) => {
      let model = {
        'filter': 'isactive eq 1',
        'order_by': { field: 'name', asc_or_desc: 'asc' }
      }
      axios.post('salesaccounts/query', model)
        .then((response) => {
          let model = { type: 'listOfSalesAccounts', data: response.data }
          commit('listValues', model)
          resolve()
        })
    })
  },
  /**
   * GET ALL USERS
   */
  getUsers ({ commit }) {
    return new Promise((resolve, reject) => {
      let model = {
        'order_by': {
          'field': 'firstname',
          'asc_or_desc': 'asc'
        },
        'filter': 'isactive eq 1'
      }
      axios.post('users/query', model)
        .then((response) => {
          if (response.data.length > 0) {
            response.data.forEach(element => {
              element.fullname = element.lastname ? `${element.firstname} ${element.lastname}` : `${element.firstname}`
              element.alternateid = JSON.parse(JSON.stringify(`user_${element.id}`))
              element.isUser = true
            })
            resolve(response.data)
          }
          let model = { type: 'listOfUsers', data: response.data }
          commit('listValues', model)
          resolve(response.data)
        })
    })
  },
  /**
   * GET ALL MAILBOX
  */
  getMailbox ({ commit }) {
    return new Promise((resolve, reject) => {
      let model = {
        'select': ['id', 'name']
      }
      axios.post('mailconfigurations/query', model)
        .then((response) => {
          let model = { type: 'listOfMailboxes', data: response.data }
          commit('listValues', model)
          resolve()
        })
    })
  },
  /**
   * GET USER'S GROUP MAILBOXES
  */
  getUserGroupMailbox ({ state, commit }) {
    return new Promise((resolve, reject) => {
      axios.get('groups/get_my_mailboxes').then((response) => {
        if (response && response.data) {
          let obj = response.data
          let mailboxes = obj.mailboxes || []
          let model = { type: 'listOfUserGroupMailboxes', data: mailboxes }
          commit('listValues', model)
          resolve()
        }
      })
    })
  },
  /**
   * GET ALL STATUS
  */
  getStatus ({ commit }) {
    return new Promise((resolve, reject) => {
      let model = {
        'filter': 'isactive eq 1'
      }
      axios.post('ticketstatuslists/query', model)
        .then((response) => {
          let model = { type: 'listOfTicketStatus', data: response.data }
          commit('listValues', model)
          resolve()
        })
    })
  },
  /**
   * GET ALL PRIORITY
  */
  getPriority ({ commit }) {
    return new Promise((resolve, reject) => {
      let model = {
        'filter': 'isactive eq 1',
        'order_by': { field: 'name', asc_or_desc: 'asc' }
      }
      axios.post('priorities/query', model)
        .then((response) => {
          let model = { type: 'listOfTicketPriorities', data: response.data }
          commit('listValues', model)
          resolve()
        })
    })
  },
  /**
   * GET ALL Customer PRIORITY
  */
  getCustomerPriority ({ commit }) {
    return new Promise((resolve, reject) => {
      let model = {
        'filter': 'isactive eq 1',
        'order_by': {
          'field': 'name',
          'asc_or_desc': 'asc'
        }
      }
      axios.post('customerpriorities/query', model)
        .then((response) => {
          let model = { type: 'listOfCustomerPriorities', data: response.data }
          commit('listValues', model)
          resolve()
        })
    })
  },
  /**
   * GET ALL Customer PRIORITY
  */
  getCustomerIndustry ({ commit }) {
    return new Promise((resolve, reject) => {
      let model = {
        'filter': 'isactive eq 1',
        'order_by': {
          'field': 'name',
          'asc_or_desc': 'asc'
        }
      }
      axios.post('customerindustries/query', model)
        .then((response) => {
          let model = { type: 'listofCustomerIndustries', data: response.data }
          commit('listValues', model)
          resolve()
        })
    })
  },
  /**
   * GET ALL Customer SHIPMENTS
  */
  getCustomerShipment ({ commit }) {
    return new Promise((resolve, reject) => {
      let model = {
        'filter': 'isactive eq 1',
        'order_by': {
          'field': 'name',
          'asc_or_desc': 'asc'
        }
      }
      axios.post('customershipments/query', model)
        .then((response) => {
          let model = { type: 'listofCustomerShipments', data: response.data }
          commit('listValues', model)
          resolve()
        })
    })
  },
  /**
   * GET ALL Payment terms
  */
  getPaymentTerms ({ commit }, days) {
    return new Promise((resolve, reject) => {
      let model = {
        'order_by': {
          'field': 'days',
          'asc_or_desc': 'asc'
        },
        'filter': 'isactive eq 1'
      }
      axios.post('paymentterms/query', model)
        .then((response) => {
          let data = response.data.map(x => {
            x.name = `${x.days} ${days}`
            return x
          })
          let model = { type: 'listOfPaymentTerms', data }
          commit('listValues', model)
          resolve()
        })
    })
  },
  /**
   * GET ALL Delivery terms
  */
  getDeliveryTerms ({ commit }) {
    return new Promise((resolve, reject) => {
      let model = {
        'order_by': {
          'field': 'name',
          'asc_or_desc': 'asc'
        },
        'filter': 'isactive eq 1'
      }
      axios.post('deliveryterms/query', model)
        .then((response) => {
          let model = { type: 'listOfDeliveryTerms', data: response.data }
          commit('listValues', model)
          resolve()
        })
    })
  },
  /**
   * GET ALL TYPES
  */
  getTypes ({ commit }) {
    return new Promise((resolve, reject) => {
      let model = {
        'filter': 'isactive eq 1',
        'order_by': { field: 'name', asc_or_desc: 'asc' }
      }
      axios.post('tickettypes/query', model)
        .then((response) => {
          let model = { type: 'listOfTypes', data: response.data }
          commit('listValues', model)
          resolve()
        })
    })
  },
  /**
   * GET ALL ROLES
  */
  getUserRoles ({ commit }) {
    return new Promise((resolve, reject) => {
      let model = {
        'filter': 'isactive eq 1',
        'order_by': { field: 'name', asc_or_desc: 'asc' }
      }
      axios.post('userroles/query', model)
        .then((response) => {
          let model = { type: 'listOfUserRoles', data: response.data }
          commit('listValues', model)
          resolve()
        })
    })
  },
  /**
   * GET ALL GROUPS
  */
  getGroups ({ commit }) {
    return new Promise((resolve, reject) => {
      let model = {}
      axios.post('groups/query', model)
        .then((response) => {
          if (response.data) {
            response.data.map(x => {
              x.fullname = x.name
              x.alternateid = JSON.parse(JSON.stringify(`group_${x.id}`))
              x.isGroup = true
              return x
            })
          }
          let model = { type: 'listOfGroups', data: response.data }
          commit('listValues', model)
          resolve()
        })
    })
  },
  /**
   * GET ALL PRODUCT GROUPS
  */
  getProductGroups ({ commit }) {
    return new Promise((resolve, reject) => {
      let model = {
        'order_by': {
          'field': 'number',
          'asc_or_desc': 'asc'
        },
        'filter': 'isactive eq 1'
      }
      axios.post('productgroups/query', model)
        .then((response) => {
          let model = { type: 'listOfProductGroups', data: response.data }
          commit('listValues', model)
          resolve()
        })
    })
  },
  /**
    * GET ALL DEVIATION CATEGORY
  */
  getDeviationCategory ({ commit }) {
    return new Promise((resolve, reject) => {
      let model = {
        'filter': 'isactive eq 1',
        'order_by': { field: 'name', asc_or_desc: 'asc' }
      }
      axios.post('deviationcategories/query', model)
        .then((response) => {
          let model = { type: 'listOfDevationCategory', data: response.data }
          commit('listValues', model)
          resolve()
        })
    })
  },
  /**
   * GET ALL DEVIATION STATUS
  */
  getDeviationStatus ({ commit }) {
    return new Promise((resolve, reject) => {
      let model = {
        'filter': 'isactive eq 1',
        'order_by': { field: 'name', asc_or_desc: 'asc' }
      }
      axios.post('deviationstatuses/query', model)
        .then((response) => {
          let model = { type: 'listOfDevationStatus', data: response.data }
          commit('listValues', model)
          resolve()
        })
    })
  },
  /**
    * GET ALL DEVIATION MEASURE CATEGORY
  */
  getDeviationMeasureCategory ({ commit }) {
    return new Promise((resolve, reject) => {
      let model = {
        'filter': 'isactive eq 1',
        'order_by': { field: 'name', asc_or_desc: 'asc' }
      }
      axios.post('deviationmeasurecategories/query', model)
        .then((response) => {
          let model = { type: 'listOfDevationMeasureCategory', data: response.data }
          commit('listValues', model)
          resolve()
        })
    })
  },
  /**
   * GET ALL DEVIATION MEASURE STATUS
  */
  getDeviationMeasureStatus ({ commit }) {
    return new Promise((resolve, reject) => {
      let model = {
        'filter': 'isactive eq 1',
        'order_by': { field: 'name', asc_or_desc: 'asc' }
      }
      axios.post('measurestatuslists/query', model)
        .then((response) => {
          let model = { type: 'listOfDevationMeasureStatus', data: response.data }
          commit('listValues', model)
          resolve()
        })
    })
  },
  /**
   * GET ALL DEVIATION LOCATION
  */
  getDeviationLocation ({ commit }) {
    return new Promise((resolve, reject) => {
      let model = {
        'filter': 'isactive eq 1',
        'order_by': { field: 'name', asc_or_desc: 'asc' }
      }
      axios.post('deviationlocations/query', model)
        .then((response) => {
          let model = { type: 'listOfDevationLocation', data: response.data }
          commit('listValues', model)
          resolve()
        })
    })
  },
  /**
   * GET ALL SUPPLIERS
  */
  getSupplierList ({ commit }) {
    return new Promise((resolve, reject) => {
      let model = {
        'filter': 'isactive eq 1 AND issupplier eq 1',
        'order_by': {
          'field': 'name',
          'asc_or_desc': 'asc'
        }
      }
      axios.post('customers/query', model)
        .then((response) => {
          let model = { type: 'listOfSuppliers', data: response.data }
          commit('listValues', model)
          resolve()
        })
    })
  },
  /**
   * GET ALL TICKET CATEGORY
  */
  getTicketCategory ({ commit }) {
    return new Promise((resolve, reject) => {
      let model = {
        'filter': 'isactive eq 1',
        'order_by': { field: 'name', asc_or_desc: 'asc' }
      }
      axios.post('categories/query', model)
        .then((response) => {
          let model = { type: 'listOfTicketCategories', data: response.data }
          commit('listValues', model)
          resolve()
        })
    })
  },
  /**
   * GET ALL SUPPLIERS
  */
  getCustomersList ({ commit }) {
    return new Promise((resolve, reject) => {
      let model = {
        'order_by': {
          'field': 'name',
          'asc_or_desc': 'asc'
        },
        'filter': 'isactive eq 1 AND iscustomer eq 1'
      }
      axios.post('customers/query', model)
        .then((response) => {
          let model = { type: 'listOfCustomers', data: response.data }
          commit('listValues', model)
          resolve()
        })
    })
  },
  /**
   * GET ALL CUSTOMERS (INCLUDING INACTIVE)
  */
  getAllCustomersIncludingInactive ({ commit }) {
    return new Promise((resolve, reject) => {
      let model = {
        'order_by': {
          'field': 'name',
          'asc_or_desc': 'asc'
        },
        'filter': 'iscustomer eq 1'
      }
      axios.post('customers/query', model)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getAllSuppliersIncludingInactive ({ commit }) {
    return new Promise((resolve, reject) => {
      let model = {
        'filter': 'issupplier eq 1',
        'order_by': {
          'field': 'name',
          'asc_or_desc': 'asc'
        }
      }
      axios.post('customers/query', model)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  /**
   * GET ALL CURRENCY
  */
  getCurrencyList ({ commit }) {
    return new Promise((resolve, reject) => {
      let query = {
        'order_by': { field: 'name', asc_or_desc: 'asc' }
      }
      axios.post('currencies/query', query)
        .then((response) => {
          let model = { type: 'listOfCurrency', data: response.data }
          commit('listValues', model)
          resolve()
        })
    })
  },
  /**
   * GET ALL WAREHOUSE
   */
  getWarehouse ({ commit }) {
    return new Promise((resolve, reject) => {
      let model = {
        'filter': 'isactive eq 1',
        'order_by': { field: 'name', asc_or_desc: 'asc' }
      }
      axios.post('warehouses/query', model)
        .then((response) => {
          let model = { type: 'listOfWarehouse', data: response.data }
          commit('listValues', model)
          resolve()
        })
    })
  },
  /**
   * GET ALL WAREHOUSE LOCATIONS
   */
  getWarehouseLocations ({ commit }) {
    return new Promise((resolve, reject) => {
      let model = {
        'filter': 'isactive eq 1',
        'order_by': {
          'field': 'name',
          'asc_or_desc': 'asc'
        }
      }
      axios.post('warehouselocations/query', model)
        .then((response) => {
          let model = { type: 'listOfLocations', data: response.data }
          commit('listValues', model)
          resolve()
        })
    })
  }
}
